import { EffectCallback, useEffect } from "react";

export function useOnFirstRender(effect: EffectCallback) {
  /* eslint-disable */
  return useEffect(effect, []);
  /* eslint-enable */
}
